import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import Tooltip from 'flarum/common/components/Tooltip';
import humanTime from 'flarum/common/helpers/humanTime';
import Icon from 'flarum/common/components/Icon';
import ItemList from 'flarum/common/utils/ItemList';
import classList from 'flarum/common/utils/classList';
import app from 'flarum/forum/app';
export default class FeaturedBlogItem extends Component {
  topItems() {
    var _article$isSticky;
    const article = this.attrs.article;
    const blogMeta = article.blogMeta();
    const tags = article.tags() || [];
    const items = new ItemList();
    items.add('tags', m("span", {
      class: "BlogFeatured-list-item-tags"
    }, tags.map(tag => m("span", {
      class: "dataItem"
    }, tag == null ? void 0 : tag.name()))), 100);

    // Sticky is an optional dependency, so we can't
    // assume method existence.
    if ((_article$isSticky = article.isSticky) != null && _article$isSticky.call(article)) {
      items.add('sticky', m("span", {
        class: "BlogFeatured-list-item-isSticky dataItem"
      }, m(Icon, {
        name: "fas fa-thumbtack"
      })), 80);
    }
    if (blogMeta && blogMeta.isPendingReview() || article.isHidden()) {
      items.add('hidden', m("span", {
        class: "BlogFeatured-list-item-isHidden dataItem"
      }, m(Icon, {
        name: "fas fa-eye-slash"
      })), 60);
    }
    if (blogMeta && blogMeta.isPendingReview()) {
      items.add('pendingReview', m(Tooltip, {
        text: app.translator.trans('fof-blog.forum.review_article.pending_review'),
        position: "bottom"
      }, m("span", {
        class: "BlogFeatured-list-item-pendingReview dataItem"
      }, m(Icon, {
        name: "far fa-clock"
      }), " ", app.translator.trans('fof-blog.forum.review_article.pending_review_title'))), 40);
    }
    return items;
  }
  dataItems() {
    const article = this.attrs.article;
    const items = new ItemList();
    const createdAt = article.createdAt();
    const user = article.user();
    items.add('createdAt', m("span", {
      class: "BlogFeatured-list-item-details-createdAt"
    }, m(Icon, {
      name: "far fa-clock"
    }), " ", createdAt ? humanTime(createdAt) : ''), 100);
    items.add('author', m("span", {
      class: "BlogFeatured-list-item-details-author"
    }, m(Icon, {
      name: "far fa-user"
    }), " ", user && user.displayName() || app.translator.trans('core.lib.username.deleted_text')), 80);
    items.add('replies', m("span", {
      class: "BlogFeatured-list-item-details-replies"
    }, m(Icon, {
      name: "far fa-comment"
    }), " ", (article.commentCount() || 0) - 1), 60);
    return items;
  }
  view(vnode) {
    const _this$attrs = this.attrs,
      article = _this$attrs.article,
      defaultImage = _this$attrs.defaultImage;
    const blogMeta = article.blogMeta();
    const tags = article.tags() || [];
    const featuredImage = blogMeta ? blogMeta.featuredImage() : null;
    const blogImage = featuredImage ? "url(".concat(featuredImage, ")") : defaultImage;
    return m(Link, {
      href: app.route('blogArticle', {
        id: "".concat(article.slug())
      }),
      className: classList('BlogFeatured-list-item', tags.map(tag => "BlogFeatured-list-item-category-".concat(tag == null ? void 0 : tag.id())), 'FoFBlog-default-image'),
      style: {
        backgroundImage: blogImage
      }
    }, m("div", {
      class: "BlogFeatured-list-item-top"
    }, this.topItems().toArray()), m("div", {
      className: 'BlogFeatured-list-item-details'
    }, m("h4", null, article.title()), m("div", {
      className: 'data'
    }, this.dataItems().toArray())));
  }
}
flarum.reg.add('fof-blog', 'forum/components/FeaturedBlogItem', FeaturedBlogItem);